import styled from '@emotion/styled';

export const SadaSchedule = styled.div``;
